<template>
<div class="chapter">
<div class="inner_page">
<h3 class="c">Seduced by Shark Shifters Three: Tom’s Turn</h3>
<p class="c1">By Rafe Jadison</p>
<p class="c1">Copyright 2017 Rafe Jadison</p>
<p class="c1">Smashwords Edition</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// tmp_61e9ec31d3854190a4dd42575e275b02_C7t4i5.ch.fixed.fc.tidied.stylehacked.xfixed_split_000.vue?23d526da